import { RepState } from "./types";
import { User } from "@/models/user_schema";

export const getAllReps = (state: RepState): User[] => {
  return state.rep;
};

export const getSelected = (state: RepState): User | null => {
  return state.selected;
};
